module.exports = __webpack_public_path__ + "media/images/cloud-attract-emblem-28df8ada5ee7f000ee5799c632b672ad.svg";